import React from 'react'
import ProgramBenefitsItem from './ProgramBenefitsItem'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    benefitsSection: {
        paddingTop: '100px',
        paddingBottom: '100px',
        backgroundColor: '#e8f1f5',
        textAlign: 'center',
        '@media screen and (max-width: 480px)': {
            paddingTop: '50px',
            paddingBottom: '50px',
        },
    },
    
    benefitsHeader: {
        marginBottom: '50px',
    },

    benefitsRow: {
        justifyContent: 'center',
    },
    col_1_5: {
        "@media (min-width: 992px)": {
            flex: '0 0 auto',
            width: '20%',
        },
    }
});

function ProgramBenefits() {

    var classes = useStyles();

    return (
        <div className={classes.benefitsSection}>
            <div className="container">
                <div className={classes.benefitsHeader}>
                    <h1>Why should you take this workshop?</h1>
                </div>
                <div className="benefits-body">
                    <div className={"row " + classes.benefitsRow} style={{justifyContent: 'center'}}>
                        <div className="col-6 col-lg-4">
                            <ProgramBenefitsItem title="What's your Entrepreneurial Quotient" subtitle="Get Insights on India's Startup Ecosystem & Government Benefits for Startups" img="/pitchbattle/images/icons/leader.png" colorClass="color1"/>
                        </div>
                        
                        <div className="col-6 col-lg-4">
                            <ProgramBenefitsItem title="1:1 Mentorship" subtitle="Get 1:1 Mentorship sessions with our Mentor Network" img="/pitchbattle/images/icons/internship.png" colorClass="color2"/>
                        </div>
                        
                        <div className="col-6 col-lg-4">
                            <ProgramBenefitsItem title="Pitch to Incubators" subtitle="Pitch your startup idea to investors & Investors" img="/pitchbattle/images/icons/resilience.png" colorClass="color3"/>
                        </div>
                        
                        <div className="col-6 col-lg-4">
                            <ProgramBenefitsItem title="Access to Startup services" subtitle="Get startup support credits such as cloud credits, licenses etc." img="/pitchbattle/images/icons/platform.png" colorClass="color4"/>
                        </div>
                        
                        <div className="col-6 col-lg-4">
                            <ProgramBenefitsItem title="Build your Network" subtitle="Get a chance to establish and nurture long-term, mutually beneficial relationships." img="/pitchbattle/images/icons/people.png" colorClass="color5"/>
                        </div>
                        
                        <div className="col-6 col-lg-4">
                            <ProgramBenefitsItem title="Get Certification" subtitle="Add the certificate to your Resume or post it directly on LinkedIn, Instagram and Twitter." img="/pitchbattle/images/icons/certificate.png" colorClass="color6"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProgramBenefits
